import { revealHiddenAddressFields } from './validation/validation.helpers';

const defaultCountry = 'GB';
const addressesUrl = '/Donation/FindAddress';
const retrieveUrl = '/Donation/SelectAddressById';
let hoveredIndex = -1;
let typingAbortController;

initAddressFinder();

/**
 * Initialises all address finder components on the page.
 * Finds every element with the `.address-finder` class and calls
 * `formAddressFinder` to wire up events for each instance.
 */
function initAddressFinder() {
	const $addressFinder = $('.address-finder');
	$addressFinder.each(function () {
		const $this = $(this);
		formAddressFinder($this);
	});
}

/**
 * Binds all keyboard, mouse, and click event handlers for a single
 * address finder component instance.
 *
 * Handles:
 * - Arrow key / Enter / Tab navigation within the results dropdown
 * - Debounced search on keyup
 * - Focus and blur styling
 * - Clear button behaviour
 * - "Enter address manually" button toggling the edit fields
 * - Auto-uppercasing the postcode field
 * - Hiding the dropdown on outside click
 *
 * @param {jQuery} $el - The `.address-finder` root element for this instance.
 */
function formAddressFinder($el) {
	const $addressFinderComponent = $el;
	const $inputSearchComponent = $addressFinderComponent.find('.input-search-component');
	const $inputSearchResults = $addressFinderComponent.find('.input-search-results');
	const $searchResultsList = $addressFinderComponent.find('.search-results-list');
	const $postcodeField = $addressFinderComponent.find('.postcode-field');
	const $showFieldsBtn = $addressFinderComponent.find('.js-enter-address-manually');
	const $closeBtn = $inputSearchComponent.find('a.close.mm-delete-icon');
	const $inputSearch = $inputSearchComponent.find('.form-control');

	$inputSearchComponent.on('mouseover', () => {
		$('body').removeClass('using-keyboard').addClass('using-mouse');
	});

	$inputSearch.on('keydown', event => {
		const $searchItems = $searchResultsList.find('.search-results-item');
		showHideCloseButton($inputSearchComponent);

		switch (event.key) {
			case 'ArrowDown':
				scrollDropDown($inputSearchComponent, 1);
				break;
			case 'ArrowUp':
				scrollDropDown($inputSearchComponent, -1);
				break;
			case 'Enter':
				event.preventDefault();
				$searchItems.eq(hoveredIndex).trigger('click');
				break;
			case 'Tab': {
					const $focusable = getFocusableElements();
					const currentIndex = $focusable.index(document.activeElement);
					if (event.shiftKey && currentIndex > 0) {
					event.preventDefault();
						$focusable.eq(currentIndex - 1).trigger('focus');
					hideAddresses($inputSearchResults);
				}
				break;
			}
		}
	});

	const debounceTimer = 300;
	const debouncedSearch = debounce(() => onInputTyping($addressFinderComponent), debounceTimer);

	$inputSearch.on('keyup', event => {
		const eKey = event.key;
		if (eKey != 'ArrowDown' && eKey != 'ArrowUp' && eKey != 'Enter') {
			debouncedSearch();
		}
	});

	$inputSearch.on('focus', () => {
		inputFocus($addressFinderComponent);
		$searchResultsList.scrollTop(0);
	});

	$closeBtn.on('click', function () {
		clearInput($inputSearchComponent);
		$inputSearch.trigger('focus');
	});

	$closeBtn.on('keydown', event => {
		switch (event.key) {
			case 'ArrowUp':
			case 'ArrowDown':
				event.preventDefault();
				break;
			case 'Enter':
				$(this).trigger('click');
				break;
			case 'Tab':
				hideAddresses($inputSearchResults);
				break;
		}
	});

	$showFieldsBtn.on('click', (e) => {
		revealHiddenAddressFields(e, $showFieldsBtn[0]);
	});

	$postcodeField.on('keyup', function () {
		$(this).val($(this).val().toUpperCase());
	});

	$(document).on('click', function () {
		hideFocus($addressFinderComponent);
	});
}

/**
 * Returns all visible, keyboard-focusable elements in the document.
 * Replaces the jQuery UI-only `:focusable` selector with a standard selector list.
 *
 * @returns {jQuery} Focusable elements.
 */
function getFocusableElements() {
	return $(
		'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
	).filter(function () {
		return $(this).is(':visible');
	});
}

/**
 * Applies focused styling to the search input component.
 *
 * @param {jQuery} $el - The `.address-finder` root element.
 */
function inputFocus($el) {
	const $inputSearchComponent = $el;
	const $inputSearch = $inputSearchComponent.find('.form-control');
	$inputSearchComponent.addClass('input-search-component--focused');
	$inputSearch.addClass('input-focus');
}

/**
 * Removes focused styling and hides the results dropdown.
 * Called when the user clicks outside the address finder component.
 *
 * @param {jQuery} $el - The `.address-finder` root element.
 */
function hideFocus($el) {
	const $addressFinderComponent = $el;
	const $inputSearchComponent = $addressFinderComponent.find('.input-search-component');
	const $searchResults = $addressFinderComponent.find('.input-search-results');
	const $inputSearch = $inputSearchComponent.find('.form-control');

	$inputSearchComponent.children($searchResults).removeClass('input-search-results--visible');
	$inputSearch.removeClass('remove-border-radius');
	$inputSearchComponent.removeClass('input-focus');
}

/**
 * Shows or hides the clear (×) button based on whether the search input has a value.
 * Also removes the square-bottom border styling when the input is empty.
 *
 * @param {jQuery} $el - The `.input-search-component` element.
 */
function showHideCloseButton($el) {
	const $inputSearchComponent = $el;
	const $inputSearch = $inputSearchComponent.find('.form-control');
	const $closeBtn = $inputSearchComponent.find('.close');
	if ($inputSearch.val().toString().length > 0) {
		$closeBtn.show();
	} else {
		$closeBtn.hide();
		$inputSearch.removeClass('remove-border-radius');
	}
}

/**
 * Clears the search input and hides the results dropdown and close button.
 * Resets all associated CSS state classes.
 *
 * @param {jQuery} $el - The `.input-search-component` element.
 */
function clearInput($el) {
	const $inputSearchComponent = $el;
	const $inputSearch = $inputSearchComponent.find('.form-control');
	const $searchResults = $inputSearchComponent.find('.input-search-results ');
	const $closeBtn = $inputSearchComponent.find('.close');

	$inputSearch.removeClass('input-focus remove-border-radius');
	$searchResults.removeClass('input-search-results--visible');
	$closeBtn.hide();

	clearText($inputSearch);
}

/**
 * Hides the address results dropdown and resets associated CSS state classes
 * across all address finder instances on the page.
 *
 * @param {jQuery} inputSearch - The `.input-search-results` element to hide.
 */
function hideAddresses(inputSearch) {
	const input = $('.input-search-component .form-control');
	inputSearch.removeClass('input-search-results--visible');
	input.removeClass('remove-border-radius');
	$(`.input-search-component input[data-type='text']`).removeClass(
		'input-focus'
	);
}

/**
 * Shows the address results dropdown and applies the open-state CSS classes.
 *
 * @param {jQuery} inputSearch - The `.input-search-results` element to show.
 */
function showAddresses(inputSearch) {
	const input = $('.input-search-component .form-control');
	inputSearch.addClass('input-focus');
	inputSearch.addClass('input-search-results--visible');
	input.addClass('remove-border-radius');
}

/**
 * Synchronises a custom-styled country `<select>` to a given ISO 2 country code.
 * Updates the underlying `<select>` selectedIndex, the visible label text,
 * and the `same-as-selected` highlight on the custom dropdown option list.
 *
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code (e.g. `'GB'`).
 * @param {jQuery} select      - The `.custom-default-select` wrapper element.
 */
function selectCountry(countryCode, select) {
	const $selectList = select;
	$selectList.find('select option').each(function (i, option) {
		if ($(option).attr('value') === countryCode) {
			$selectList.find('select').prop('selectedIndex', i);
			let country = $(option).text();
			$selectList.find('.selected-value ').html(country);
			$selectList
				.find('.option-item.same-as-selected')
				.removeClass('same-as-selected');
			$selectList
				.find('.option-item')
				.filter(function () {
					return $(this).text() === country;
				})
				.addClass('same-as-selected');
		}
	});
}

/**
 * Clears the value of a jQuery-wrapped form field.
 *
 * @param {jQuery} field - The input element to clear.
 */
function clearText(field) {
	field.val('');
}

/**
 * Moves keyboard focus within the results dropdown by the given increment,
 * wrapping at the top and bottom of the list. Updates ARIA attributes
 * (`aria-selected`, `aria-activedescendant`) and scrolls the panel to keep
 * the highlighted item visible.
 *
 * @param {jQuery} $el       - The `.input-search-component` element.
 * @param {number} increment - Direction to move: `1` for down, `-1` for up.
 */
function scrollDropDown($el, increment) {
	const $inputSearchComponent = $el;
	const $inputSearchResults = $inputSearchComponent.find('.input-search-results');
	const $searchItems = $inputSearchComponent.find('.search-results-item');
	const itemsLength = $searchItems.length - 1;
	const panelHeight = $inputSearchResults.outerHeight();
	let yPos = 0;

	hoveredIndex += increment;

	if (hoveredIndex < 0) hoveredIndex = itemsLength;
	if (hoveredIndex > itemsLength) hoveredIndex = 0;
	$searchItems.removeClass('hovered-item').removeAttr('aria-selected');
	$($searchItems[hoveredIndex]).addClass('hovered-item').attr('aria-selected', 'true');
	const $textbox = $inputSearchComponent.find('.form-control');
	$textbox.attr('aria-activedescendant', $searchItems[hoveredIndex].id);

	$searchItems.each((index, item) => {
		if (index <= hoveredIndex) {
			yPos += $(item).outerHeight();
		}
	});

	const nextPosition = yPos - panelHeight + 12;
	$inputSearchResults.animate({ scrollTop: nextPosition }, 200);
}

/**
 * Returns a debounced version of the provided function that delays execution
 * until `delay` milliseconds have elapsed since the last invocation.
 *
 * @param {Function} func  - The function to debounce.
 * @param {number}   delay - Delay in milliseconds.
 * @returns {Function} The debounced function.
 */
function debounce(func, delay) {
	let timer;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => func.apply(this, args), delay);
	};
}

/**
 * Handles user typing in the search input. Cancels any in-flight request via
 * AbortController, then triggers a new address search if the input meets the
 * minimum length. Hides the dropdown when the input is cleared.
 *
 * Also attaches delegated click handlers on the results list for:
 * - `.multiple-addresses` items — drills down via `showNestedResults`
 * - `.single-address` items — populates address fields via `populateFieldsOfAddress`
 *
 * @param {jQuery} $el - The `.address-finder` root element.
 */
function onInputTyping($el) {
	const $addressFinderComponent = $el;
	const $inputSearchComponent = $addressFinderComponent.find('.input-search-component');
	const $searchResults = $addressFinderComponent.find('.input-search-results');
	const $inputSearch = $inputSearchComponent.find('.form-control');
	const $addressLookup = $addressFinderComponent.find('.address-lookup');
	const $searchResultsList = $addressFinderComponent.find('.search-results-list');
	const $closeBtn = $inputSearchComponent.find('.close');
	const inputValue = $inputSearch.val().trimStart();
	const minSearchLength = 1;

	if (inputValue.length >= minSearchLength) {
		if (typingAbortController) {
			typingAbortController.abort();
		}

		typingAbortController = new AbortController();
		const signal = typingAbortController.signal;

		findAddresses($addressLookup, inputValue, addressesUrl, signal);

		$searchResultsList.on('click', '.search-results-item.multiple-addresses', function (event) {
			event.stopImmediatePropagation();
			const thisEvent = event;
			showNestedResults($addressFinderComponent, thisEvent, addressesUrl);
		});

		$searchResultsList.on('click', '.single-address', function (event) {
			event.stopImmediatePropagation();
			const thisEvent = event;
			populateFieldsOfAddress($addressFinderComponent, thisEvent, retrieveUrl, $inputSearch);
			$closeBtn.hide();
		});
	} else {
		hideAddresses($searchResults);
	}
}

/**
 * Makes a GET request to the address search endpoint and renders the results
 * as a dropdown list. Each result is classified as either a `single-address`
 * (a specific property) or `multiple-addresses` (a container such as a street
 * or building that can be drilled into).
 *
 * Updates ARIA attributes (`aria-expanded`, `aria-activedescendant`) and
 * announces the result count to screen readers via a live region.
 *
 * @param {jQuery} $el     - The `.address-lookup` element within the component.
 * @param {string} value   - The current search text entered by the user.
 * @param {string} country - ISO 3166-1 alpha-2 country code; defaults to `'GB'` if undefined.
 * @param {string} url     - The endpoint URL (e.g. `/Donation/FindAddress`).
 * @param {AbortSignal} signal - AbortSignal used to cancel the request if the user keeps typing.
 */
function findAddresses($el, value, url, signal) {
	const $addressFinder = $el;
	const $combobox = $addressFinder.find('.address-input-combobox');
	const $searchResultsList = $addressFinder.find('.search-results-list');
	const $inputSearchField = $addressFinder.find('.form-control');
	const $searchResults = $addressFinder.find('.input-search-results');
	const $resultStatus = $addressFinder.find('.results-status');
	const $noResultMsg = $searchResults.find('.no-results-msg');
	const $noServiceAvailableMsg = $searchResults.find('.no-service-available-msg');
	let searchUrl;

	searchUrl = `${url}?Text=${value}`

	$.ajax({
		url: searchUrl,
		method: 'GET',
		signal,
		success: function (response) {
			const data = response;
			$searchResultsList.empty();
			if (!data || data.length === 0) {
				$noResultMsg.removeClass('d-none');
				$searchResultsList.hide();
				$combobox.attr('aria-expanded', 'false');
				$inputSearchField.attr('aria-expanded', 'false');
				return;
			} else {
				$searchResultsList.show();
				const resultsCount = data.length;
				$combobox.attr('aria-expanded', 'true');
				$inputSearchField.attr('aria-expanded', 'true');
				setTimeout(() => { $resultStatus.text(`${resultsCount} results available`) }, 1000);
			}

			$noResultMsg.addClass('d-none');
			$noServiceAvailableMsg.addClass('d-none');

			data.forEach((item, index) => {
				const searchResultListItem = `
					<div id="address-${index}" role="option" class='search-results-item ${item.Type === 'Address' ? 'single-address' : 'multiple-addresses'}' data-code='${item.Id}'>
						${item.Text}
						<div class='description'>${item.Description}</div>
					</div>`;
				$searchResultsList.append(searchResultListItem);
			});

			hoveredIndex = 0;
			const firstId = 'address-0';
			$searchResultsList.find(`#${firstId}`).addClass('hovered-item').attr('aria-selected', 'true');
			$inputSearchField.attr('aria-activedescendant', firstId);

			if ($inputSearchField.val().length > 0) {
				showAddresses($searchResults);
			}
		},
		error: function () {
			$noServiceAvailableMsg.removeClass('d-none');
		}
	});
}

/**
 * Drills down into a container result (e.g. a building or street) by fetching
 * the individual addresses within it. Replaces the current results list with
 * the nested addresses and resets keyboard navigation state.
 *
 * @param {jQuery} $el   - The `.address-finder` root element.
 * @param {Event}  event - The click event on the container result item.
 * @param {string} url   - The endpoint URL to fetch nested results from.
 */
function showNestedResults($el, event, url) {
	event.stopPropagation();
	const $addressFinderComponent = $el;
	const $inputSearchResults = $addressFinderComponent.find('.input-search-results');
	const $searchResultsList = $addressFinderComponent.find('.search-results-list');
	const $searchResultsItem = $addressFinderComponent.find('.search-results-item');
	const $textbox = $addressFinderComponent.find('.form-control');
	const $resultStatus = $addressFinderComponent.find('.results-status');
	const currentTarget = $(event.currentTarget);
	const itemId = currentTarget.attr('data-code');
	const inputValue = currentTarget.val();
	hoveredIndex = -1;

	$searchResultsItem.removeClass('hovered-item');

	const requestUrl = `${url}?Text=${inputValue}&Container=${itemId}`;

	$.get(requestUrl)
		.done((response) => {
			const data = typeof response === "string" ? JSON.parse(response) : response;

			if (!data || data.length === 0) {
				console.warn("No items found in response.");
				$searchResultsList.empty();
				return;
			}

			const resultsHtml = data.map((item, index) => {
				return `
				<div id="address-${index}" role="option" class="search-results-item single-address" data-code="${item.Id}" data-type="${item.Type}">
					${item.Text}
					<div class="description">${item.Description}</div>
				</div>
			`;
			}).join("");

			$searchResultsList.empty().append(resultsHtml);
			showAddresses($inputSearchResults);
			hoveredIndex = 0;
			const firstId = 'address-0';
			$searchResultsList.find('#' + firstId).addClass('hovered-item').attr('aria-selected', 'true');
			$textbox.attr({ 'aria-activedescendant': firstId, 'aria-expanded': 'true' }).trigger('focus');
			$resultStatus.text(`${data.length} results available`);

			$searchResultsList.off("click").on("click", ".single-address", function (event) {
				event.stopPropagation();
				populateFieldsOfAddress($addressFinderComponent, event, retrieveUrl, currentTarget);
			});
		})
		.fail((error) => {
			console.error("Error fetching nested results:", error);
		});
}

/**
 * Fetches the full address detail for a selected result and populates the
 * visible address form fields. Field matching is done by comparing the
 * `data-key` attribute on each input against the response property names
 * (case-insensitive).
 *
 * After population:
 * - Syncs the country dropdown via `selectCountry`
 * - Triggers `keyup` on all text inputs to fire any validation listeners
 * - Hides the results dropdown and the "Enter address manually" button
 *
 * @param {jQuery} $el         - The `.address-finder` root element.
 * @param {Event}  event       - The click event on the selected address result.
 * @param {string} url         - The endpoint URL (e.g. `/Donation/SelectAddressById`).
 * @param {jQuery} inputSearch - The search input element, cleared after selection.
 */
function populateFieldsOfAddress($el, event, url, inputSearch) {
	event.stopImmediatePropagation();
	event.stopPropagation();
	const $addressFinderComponent = $el;
	const $inputSearchResults = $addressFinderComponent.find('.input-search-results');
	const selectList = $addressFinderComponent.find('.custom-default-select');
	const postcodeField = $addressFinderComponent.find('.postcode-field');
	const $showFieldsBtn = $addressFinderComponent.find('.js-enter-address-manually');
	const $currentTarget = $(event.currentTarget);
	const itemId = $currentTarget.attr('data-code');

	const requestUrl = `${url}?Id=${itemId}`;

	$.get(requestUrl).done((response) => {
		const $editFields = $addressFinderComponent.find('.edit-fields'); // Cache the container for better performance
		const data = typeof response === 'string' ? JSON.parse(response) : response;
		const addressData = data || {}; // Safely access the first item

		Object.entries(addressData).forEach(([key, value]) => {
			const lowerKey = key.toLowerCase(); // Convert the key to lowercase
			const field = $editFields.find('[data-key]').filter(function () {
				return $(this).attr('data-key').toLowerCase() === lowerKey;
			});

			if (field.length > 0) {
				field.val(value);
				field.valid();
			} else {
				console.warn(`Field with data-key='${lowerKey}' not found.`);
			}

			if (lowerKey === 'countryiso2' && value === 'GB') {
				postcodeField.addClass('text-uppercase');
			} else if (lowerKey === 'countryiso2') {
				postcodeField.removeClass('text-uppercase');
			}

			if (lowerKey === 'provincename' && !value) {
				const provinceField = $editFields.find(`[data-key='provincename']`);
				if (provinceField.length > 0) {
					provinceField.val(addressData.Province || '');
				}
			}
		});

		selectCountry(addressData.CountryIso2, selectList);

		$editFields.find('input[type=text]').trigger('keyup');
		hideAddresses($inputSearchResults);
		$editFields.show();

		if ($('.progressive-disclosure').length > 0) {
			$('.bg-md-bookend-grey').css('height', 'auto');
		}

		$showFieldsBtn.hide();
		clearText(inputSearch);

	}).fail((error) => {
		console.error('Error fetching address data:', error);
	});
}
